import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CpRefundsRequestModel } from '../../helpers/objects/request/refunds/cp-refunds-request-model';
import { map, Observable } from 'rxjs';
import { CpRefundsResponseModel } from '../../helpers/objects/response/refunds/cp-refunds-response-model';
import { CpRefundDetailModel } from '../../helpers/objects/dto/refunds/refund-detail/cp-refund-detail-model';
import { CpRefundsBodyCreateRequestModel } from '../../helpers/objects/request/refunds-body-create/cp-refunds-body-create-request-model';
import { CpRefundsBuildingsRequestModel } from '../../helpers/objects/request/refunds-buildings/cp-refunds-buildings-request-model';
import { CpRefundsBuildingsModel } from '../../helpers/objects/dto/refunds-buildings/cp-refunds-buildings-model';
import { CpRefundsInsuredPersonIbansModel } from '../../helpers/objects/dto/refunds-insured-person-ibans/cp-refunds-insured-person-ibans-model';
import { CpDocumentModel } from '../../helpers/objects/dto/document/cp-document-model';
import {
  CpRefundsItemListResponseModel
} from '../../helpers/objects/response/refunds/refunds-item-list/cp-refunds-item-list-response-model';

@Injectable({
  providedIn: 'root'
})
export class CpRefundsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  getAll(token: string, request: CpRefundsRequestModel): Observable<CpRefundsResponseModel> {
    const params = new HttpParams({
      fromObject: request as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/refunds', { params })
      .pipe(map((response) => response.body as CpRefundsResponseModel));
  }
  getUnifiedRefunds(token: string, request: CpRefundsRequestModel): Observable<CpRefundsResponseModel> {
    const params = new HttpParams({
      fromObject: request as any
    });

    return this.http.get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/unified-refunds', { params }).pipe(
      map((response) => response.body as CpRefundsResponseModel),
      map((response: CpRefundsResponseModel) => {
        response.Refunds.forEach(row => {
          AffectType(row, row.Type);

          (row.Claims ?? []).forEach(claim => {
            AffectType(claim, claim.ClaimType);
          })
        })

        return response;
      })
    );

    function AffectType(row: any, type: string) {
      switch (type) {
        case "ONLINE_PROCESS":
          row.NavigationType = 'NONE';
          break;
        case "REFUND":
        case "SINGLE_REFUND":
          row.NavigationType = 'URL';
          break;
        case "AGGREGATED_REFUND":
          row.NavigationType = 'Emitter';
          break;
      }

    }
  }
  getDetails(token: string, clinicCase: string): Observable<CpRefundDetailModel> {
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/refunds/' + encodeURIComponent(clinicCase))
      .pipe(map((response) => response.body as CpRefundDetailModel));
  }
  getBuildings(body: CpRefundsBuildingsRequestModel): Observable<CpRefundsBuildingsModel[]> {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .post<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/refunds-requests/loadBuildings', body)
      .pipe(map((response) => response.body.buildings as CpRefundsBuildingsModel[]));
  }
  getIbansInsuredPerson(cardNumber: string): Observable<CpRefundsInsuredPersonIbansModel[]> {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/refunds-requests/list-refund-payment-methods-iban/' + cardNumber)
      .pipe(map((response) => response.body.ibans as CpRefundsInsuredPersonIbansModel[]));
  }
  getFormDocuments() {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/refunds-form-documents')
      .pipe(map((response) => response.body.Documents as CpDocumentModel[]));
  }

  addDocument(data: any, token: string, clinicCase: string): Observable<any> {
    return this.http.post<any>(
      this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/refunds/' + encodeURIComponent(clinicCase) + '/documents',
      data
    );
  }
  create(body: CpRefundsBodyCreateRequestModel): Observable<any> {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .post<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/multiple-refunds-requests', body)
      .pipe(map((response) => response.body));
  }

  getHistory(token: string, clinicCase: string): Observable<any> {
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/refunds/history/' + encodeURIComponent(clinicCase))
      .pipe(map((response) => response.body.RefundHistory));
  }

}
